import { render } from "./App.vue?vue&type=template&id=6ccedad8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6ccedad8&lang=scss"

import exportComponent from "/home/m/neurometronomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__